<app-navbar-style-one></app-navbar-style-one>

<div class="inner-banner inner-bg11">
    <div class="container">
        <div class="inner-title">
            <h3>Privacy Policy</h3>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li><i class='bx bxs-chevrons-right'></i></li>
                <li>Privacy Policy</li>
            </ul>
        </div>
    </div>
</div>

<div class="privacy-policy-area ptb-100">
    <div class="container">
        <div class="single-content">
            <h3>Welcome to BBQ BAYONNE WINGS Privacy Policy</h3>
            <div class="terms-content" [innerHTML]="settings"></div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>